import React, { Component } from 'react';
import { NavLink, Link } from 'react-router-dom';
import { Badge, Nav, NavItem, NavLink as RsNavLink } from 'reactstrap';
import classNames from 'classnames';
import nav from './_nav';
import SidebarFooter from './../SidebarFooter';
import SidebarForm from './../SidebarForm';
import SidebarHeader from './../SidebarHeader';
import SidebarMinimizer from './../SidebarMinimizer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import home from '../../assets/fontawesome/home.png'
import update from '../../assets/fontawesome/update.png'
import download from '../../assets/fontawesome/download.png'
import news from '../../assets/fontawesome/news.png'
import about from '../../assets/fontawesome/about-us.png'
import companyAPI from '../../assets/fontawesome/company_api.png'
import contact from '../../assets/fontawesome/contact.png'
import recentlyAdded from '../../assets/fontawesome/recently_added.png'

import addNewCompany from '../../assets/fontawesome/addNewCompany.png'
import algo from '../../assets/fontawesome/algo.png'
import join from '../../assets/fontawesome/join.png'
import media from '../../assets/fontawesome/media.png'
import searchIcon from '../../assets/fontawesome/searchIcon.png'
import Cookies from 'js-cookie';
import { encodeforspace } from '../../utils/helper';


// import api from '../../assets/fontawesome/api.png'
import {
  BrowserView,
  MobileView,
} from "react-device-detect";
import DownloadModal from '../downloadModal'
const env = process.env.NODE_ENV || 'development';
const config = require('../../config.json')[env];
const admin_url = config.admin_url
const fileDownload = require('js-file-download');
class Sidebar extends Component {

  constructor(props) {
    super(props);

    // if(this.props.auth.user.email && !this.props.auth.user.company){
    // console.log('this.props.auth.user.email',this.props.auth.user.email, this.props.auth.user.company)
    // this.props.history.push('/logout')
    // }

    this.handleClick = this.handleClick.bind(this);
    this.activeRoute = this.activeRoute.bind(this);
    this.hideMobile = this.hideMobile.bind(this);
    this.state = {
      downloading: false,
      isLoggedIn: Cookies.get('token') || Cookies.get('accessToken') ? true : false,
      showLoggedInItems: false
    }
  }

  componentDidMount() {
    if (this.state.isLoggedIn) {
      this.setState({ showLoggedInItems: true })
    }
  }


  handleClick(e) {
    e.preventDefault();
    e.target.parentElement.classList.toggle('open');
  }

  activeRoute(routeName, props) {
    // return this.props.location.pathname.indexOf(routeName) > -1 ? 'nav-item nav-dropdown open' : 'nav-item nav-dropdown';
    return props.location.pathname.indexOf(routeName) > -1 ? 'nav-item nav-dropdown open' : 'nav-item nav-dropdown';

  }

  hideMobile(e) {
    this.setState({ downloading: false })
    // if (document.body.classList.contains('sidebar-mobile-show')) {
    //   document.body.classList.toggle('sidebar-mobile-show')
    // }
    if (e.target.href.includes('/news')) {
      e.preventDefault()
      window.location.href = 'https://blog.growjo.com/';
    }
  }
  download = (e) => {
    e.preventDefault();
    this.setState({ downloading: true })
    fetch(`${admin_url}/csvs?_sort=id:DESC&_limit=1`)
      .then(response => response.json())
      .then(res => {
        fileDownload(`${admin_url}${res[0].file.url}`, 'exportlist.csv')
      })
  }
  // todo Sidebar nav secondLevel
  // secondLevelActive(routeName) {
  //   return this.props.location.pathname.indexOf(routeName) > -1 ? "nav nav-second-level collapse in" : "nav nav-second-level collapse";
  // }


  render() {

    const props = this.props;

    // badge addon to NavItem
    const badge = (badge) => {
      if (badge) {
        const classes = classNames(badge.class);
        return (<Badge className={classes} color={badge.variant}>{badge.text}</Badge>)
      }
    };

    // simple wrapper for nav-title item
    const wrapper = item => { return (item.wrapper && item.wrapper.element ? (React.createElement(item.wrapper.element, item.wrapper.attributes, item.name)) : item.name) };

    // nav list section title
    const title = (title, key) => {
      const classes = classNames('nav-title', title.class);
      return (<li key={key} className={classes}>{wrapper(title)} </li>);
    };

    // nav list divider
    const divider = (divider, key) => {
      const classes = classNames('divider', divider.class);
      return (<li key={key} className={classes}></li>);
    };

    // nav item with nav link
    const navItem = (item, key) => {
      const classes = {
        item: classNames(item.class),
        link: classNames('nav-link', item.variant ? `nav-link-${item.variant}` : ''),
        icon: classNames(item.icon)
      };
      return (
        navLink(item, key, classes)
      )
    };

    // nav link
    const navLink = (item, key, classes) => {
      const url = item.url ? item.url : '';
      var img_name;
      let showItem = true;

      if (!this.state.isLoggedIn && (item.icon == 'search')) {
        return

      }

      if (item.icon == 'fa fa-download') {
        showItem = false;
      }

      switch (item.icon) {
        case 'download':
          // code block
          img_name = download
          break;
        case 'join':
          // code block
          img_name = join
          break;
        case 'media':
          // code block
          img_name = media
          break;
        case 'news':
          // code block
          img_name = news
          break;
        case 'update':
          // code block
          img_name = update
          break;
        case 'home':
          // code block
          img_name = home
          break;
        case 'search':
          // code block
          img_name = searchIcon
          break;
        case 'algo':
          // code block
          img_name = algo
          break;
        case 'about':
          // code block
          img_name = about
          break;

        case 'addyourcompany':
          // code block
          img_name = addNewCompany
          break;

        case 'contact':
          img_name = contact
          break;

        case 'recently_added':
          img_name = recentlyAdded
          break;

        case 'company_api':
          img_name = companyAPI
          break;

        default:
        // code block
      }

      // img_name = join
      return (
        (showItem || this.state.showLoggedInItems) && (
          <NavItem key={key} className={classes.item}>
            {item.icon == 'icon-login' || item.icon == 'icon-logout' || item.icon == 'fa fa-line-chart' || item.icon == 'fa fa-download' || item.icon == 'fa fa-address-card' ?
              <NavLink exact to={url} className={classes.link} activeClassName="active" name={classes.item} onClick={() => this.hideMobile()}>
                <i className={classes.icon} style={{ fontSize: 18, opacity: 0.5, fontWeight: 'bold' }}></i>{item.name}{badge(item.badge)}
              </NavLink> :
              <NavLink exact to={url} className={classes.link} activeClassName="active" name={classes.item} onClick={() => this.hideMobile()}>
                <img className='img' src={img_name} style={{ marginRight: 10, marginTop: -5, width: 20, height: 20 }} />{item.name}{badge(item.badge)}
              </NavLink>
            }
          </NavItem>
        ))
    };

    // nav dropdown
    const navDropdown = (item, key) => {
      return (
        <li key={key} className={this.activeRoute(item.url, props)}>
          <a className="nav-link nav-dropdown-toggle" href="#" onClick={this.handleClick}><i className={item.icon}></i>{item.name}</a>
          <ul className="nav-dropdown-items">
            {navList(item.children)}
          </ul>
        </li>)
    };

    // nav type
    const navType = (item, idx) =>
      item.title ? title(item, idx) :
        item.divider ? divider(item, idx) :
          item.children ? navDropdown(item, idx)
            : navItem(item, idx);

    // nav list
    // const navList = (items) => {
    //   return items.map( (item, index) => navType(item, index) );
    // };

    const navList = (items) => {
      var _this = this;

      return items.map((item, index) => {
        let afterLoginPages = ['Logout', 'My Company', 'Update Company', 'Register Company']
        if (afterLoginPages.indexOf(item.name) >= 0) {
          return false; // skip
        }
        if (_this.state.isLoggedIn) {
          if (item.name == 'Home') {
            item.url = '/search';
          }
          let userCompany = this.props.auth.user.company
          let beforeLoginPages = ['Sign In', 'Join']
          if (beforeLoginPages.indexOf(item.name) >= 0) {
            return false; // skip
          }
          if (item.name == 'My Company' || item.name == 'Update Company') {
            if (userCompany && userCompany.company_name) {
              if (item.name == 'My Company')
                item.url = '/company/' + encodeforspace(userCompany.company_name)
              else
                item.url = '/edit_company/' + encodeforspace(userCompany.company_name)
            } else {
              return false
            }
          } else if (item.name == 'Register Company') {
            if (userCompany && userCompany.company_name) {
              return false
            }
          }
        } else {
          // let afterLoginPages = ['Export']
          // if (afterLoginPages.indexOf(item.name) >= 0) {
          //   return false; // skip
          // }


        }
        return navType(item, index)
      });
    };

    const isExternal = (url) => {
      const link = url ? url.substring(0, 4) : '';
      return link === 'http';
    };

    // if(!this.state.isLoggedIn){
    //   nav.items = nav.items.filter(item => item.name !== 'Export')
    // }

    // sidebar-nav root
    return (
      <div className="sidebar">
        <SidebarHeader />
        <SidebarForm />
        <nav className="sidebar-nav">
          <Nav>
            {/* <MobileView>
              <Link to='/' className="mobile-navbar-brand" onClick={e => this.hideMobile(e)} />
            </MobileView> */}
            {navList(nav.items)}
          </Nav>
        </nav>
        <SidebarFooter />
        {/* <SidebarMinimizer/> */}
        <DownloadModal modalIsOpen={this.state.downloading} closeModal={() => this.setState({ downloading: false })} />
      </div>
    )
  }
}

export default Sidebar;



// WEBPACK FOOTER //
// ./client/src/components/Sidebar/Sidebar.js